import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../../errorhandling';
import router from '../../../router/router';

let localSubscription = undefined;

async function createSubscription(store, clientId) {

	let client_uuid = "";

	let clientQuery = new Parse.Query('Client');
	clientQuery.equalTo("objectId", clientId);
	clientQuery.notEqualTo("deleted", true);
	await clientQuery.find().then(response => client_uuid = response[0].attributes.uuid);

	let all_clients = "";

	let clientQuery2 = new Parse.Query('Client');
	clientQuery2.equalTo("uuid", client_uuid);
	clientQuery2.notEqualTo("deleted", true);
	await clientQuery2.find().then(response => all_clients = response);

	let dataQuery = new Parse.Query('ClientAttendance');
	dataQuery.limit(1000000)

	dataQuery.notEqualTo("deleted", true)
	dataQuery.descending("createdAt")
	dataQuery.containedIn("client", all_clients)

	// var clientPointer = {
	// 	__type: 'Pointer',
	// 	className: 'Client',
	// 	objectId: clientId
	// }

	dataQuery.find()
		.then((results) => {
			store.dispatch('clientAttendance/set', results)
		})
		.catch((error) => {
			handleParseError(error);

		});
	dataQuery.subscribe().then((subscription) => {
		localSubscription = subscription
		subscription.on('create', object => {
			store.dispatch('clientAttendance/insert', object)
		});
		subscription.on('update', object => {
			store.dispatch('clientAttendance/replace', object)
		});
		subscription.on('enter', object => {
			store.dispatch('clientAttendance/insert', object)
		});
		subscription.on('leave', object => {
			store.dispatch('clientAttendance/delete', object)
		});
		subscription.on('delete', object => {
			store.dispatch('clientAttendance/delete', object)
		});
		subscription.on('close', () => { });
		subscription.on('error', error => { })
	})
}

export default function createClientAttendanceSubscription() {
	return store => {
		store.subscribe(mutation => {
			if (mutation.type === 'clients/SET_FOCUSED_CLIENT_ID' && (router.currentRoute.name == "Attendance")) {
				if (localSubscription) {
					localSubscription.unsubscribe();
				}
				if (mutation.payload) {
					createSubscription(store, mutation.payload)
				}
			}
		}),
			store.subscribe(mutation => {
				if (mutation.type === 'ADD_LAST_ROUTE' && (router.currentRoute.name == "Attendance")) {
					if (localSubscription) {
						localSubscription.unsubscribe();
					}
					if (store.state.clients.focusedClientId) {
						createSubscription(store, store.state.clients.focusedClientId)
					}
				}
			})
	}
}
